// API Configuration

// Determine the API URL based on environment
const getApiUrl = () => {
  // Check if we have an environment variable set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Default to production API if no env variable is set
  // You should replace this with your actual production API URL
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8000';
  }
  
  // For production (Vercel), use the production API URL
  // TODO: Replace with your actual production backend URL
  return 'https://your-backend-url.com';
};

export const API_URL = getApiUrl();

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_URL}${endpoint}`;
  
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || `Error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error(`API call failed for ${endpoint}:`, error);
    throw error;
  }
};